<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <sidebar-fixed-toggle-button />
    <side-bar
      :background-color="sidebarBackground"
      :short-title="$t('sidebar.shortTitle')"
      :title="$t('sidebar.title')"
    >
      <template slot="links">
        <sidebar-item
          v-if="sso.attendance"
          :link="{
            name: $t('sidebar.peoplemonitoring'),
            img: require('../../assets/img/People.png'),
          }"
        >
          <sidebar-item
            v-if="sso.attendance.all || sso.attendance.overview"
            :link="{
              name: $t('Attendance Overview'),
              path: '/Attendance/AttendanceOverview',
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="sso.attendance.all || sso.attendance.anal"
            :link="{
              name: $t('Attendance Analytic'),
              path: '/Attendance/Analytic',
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="sso.attendance.all || sso.attendance.overallreport"
            :link="{
              name: $t('sidebar.attendreport'),
            }"
          >
            <sidebar-item
              :link="{
                name: $t('Attendance Report'),
                path: '/Attendance/Report/Overall',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: $t('Attendance Summary'),
                path: '/Attendance/Report/Summary',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: $t('Mobile Report'),
                path: '/Attendance/Report/Mobile',
              }"
            ></sidebar-item>
          </sidebar-item>

          <sidebar-item
            v-if="sso.attendance.all || sso.attendance.scheduleedit"
            :link="{
              name: $t('Schedule Edit'),
              path: '/Attendance/ScheduleEdit',
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="sso.attendance.all || sso.attendance.empmanage"
            :link="{
              name: $t('Employee Management'),
              path: '/Attendance/EmployeeManagement',
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="sso.attendance.all || sso.attendance.shiftcode"
            :link="{
              name: $t('Shift Code Management'),
              path: '/Attendance/ShiftCodeManagement',
            }"
          ></sidebar-item>
        </sidebar-item>
        <!-- <sidebar-item
          v-if="sso.attendance.all || sso.attendance.scheduleedit"
          :link="{
            name: $t('Schedule Edit'),
            path: '/Attendance/ScheduleEdit',
            icon: 'tim-icons icon-notes'
          }"
        ></sidebar-item> -->
        <sidebar-item
          v-if="sso.asset"
          :link="{
            name: $t('sidebar.equipmentmanagementlink'),
            img: require('../../assets/img/Asset.png'),
          }"
        >
          <sidebar-item
            :link="{ name: $t('Asset Overview'), path: '/Asset/AssetOverview' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: $t('Asset Analytic'), path: '/Asset/AssetGraph' }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('sidebar.assetreport'),
            }"
          >
            <sidebar-item
              :link="{
                name: $t('Asset Details Report'),
                path: '/Asset/Report/AssetDetailsReport',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: $t('Asset Location Report'),
                path: '/Asset/Report/AssetLocationReport',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: $t('Asset Repair Report'),
                path: '/Asset/Report/AssetRepairReport',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: $t('Asset Under-repair Report'),
                path: '/Asset/Report/CorrectMaintenance',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: $t('PPM Report'),
                path: '/Asset/Report/PMMMaintenaceReport',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: $t('PPM Done Report'),
                path: '/Asset/Report/PPMDoneReport',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: $t('PPM Overdue Report'),
                path: '/Asset/Report/PPMOverdueReport',
              }"
            ></sidebar-item>
          </sidebar-item>
          <sidebar-item
            :link="{
              name: $t('Asset Relocation Request'),
              path: '/Asset/RelocationRequest',
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('Asset Relocation Approval'),
              path: '/Asset/RelocationApproval',
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: $t('Print QR Code'), path: '/Asset/AssetQR' }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('sidebar.assetmanagement'),
            }"
          >
            <sidebar-item
              :link="{
                name: $t('Asset Registration'),
                path: '/Asset/AssetRegistration',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{ name: $t('Asset Update'), path: '/Asset/AssetUpdate' }"
            ></sidebar-item>
          </sidebar-item>
        </sidebar-item>
        <sidebar-item
          v-if="sso.fleet"
          :link="{
            name: $t('sidebar.fleetmonitoring'),
            img: require('../../assets/img/Fleet Management.png'),
          }"
        >
          <sidebar-item
            :link="{
              name: $t('sidebar.vehicleoverview'),
              path: '/Fleet/Overview',
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: $t('sidebar.vehiclegraph'), path: '/Fleet/Graph' }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('sidebar.vehicleMaintenance'),
              path: '/Fleet/VehicleMaintenance',
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('sidebar.vehicleRequirement'),
              path: '/Fleet/VehicleRequirement',
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('sidebar.vehicleSite'),
              path: '/Fleet/VehicleSite',
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('sidebar.vehicleReplacement'),
              path: '/Fleet/VehicleReplacement',
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('sidebar.vehicleSearch'),
              path: '/Fleet/VehicleSearch',
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('sidebar.vehicleRegistration'),
              path: '/Fleet/VehicleRegistration',
            }"
          ></sidebar-item>
          <!-- Fleet report -->
          <sidebar-item
            :link="{
              name: $t('sidebar.vehiclereport'),
              icon: 'tim-icons icon-chart-pie-36',
            }"
          >
            <sidebar-item
              :link="{
                name: $t('sidebar.totalVehicleReport'),
                path: '/Fleet/Report/TotalVehicleReport',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: $t('sidebar.breakdownReport'),
                path: '/Fleet/Report/BreakdownReport',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: $t('sidebar.availabilityReport'),
                path: '/Fleet/Report/AvailabilityReport',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: $t('sidebar.replacementReport'),
                path: '/Fleet/Report/ReplacementReport',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: $t('sidebar.percentAvailabilityReport'),
                path: '/Fleet/Report/PercentAvailabilityReport',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: $t('sidebar.unservicedReport'),
                path: '/Fleet/Report/UnservicedReport',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: $t('sidebar.requirementReport'),
                path: '/Fleet/Report/RequirementReport',
              }"
            ></sidebar-item>
          </sidebar-item>
        </sidebar-item>
        <sidebar-item
          v-if="sso.greenCard"
          :link="{
            name: $t('sidebar.greenCard'),
            img: require('../../assets/img/Greencard.png'),
          }"
        >
          <sidebar-item
            :link="{
              name: $t('sidebar.greenOverview'),
              path: '/Greencard/Overview',
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('sidebar.greenAnalytics'),
              path: '/Greencard/Analytics',
            }"
          ></sidebar-item>
          <sidebar-item :link="{ name: $t('sidebar.greenReportPage') }">
            <sidebar-item
              :link="{
                name: $t('sidebar.crossCheck'),
                path: '/Greencard/Report/ScheduleActual',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: $t('sidebar.offSchedule'),
                path: '/Greencard/Report/ScheduleConsistency',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: $t('sidebar.missCollection'),
                path: '/Greencard/Report/MissCollection',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: $t('sidebar.customerRating'),
                path: '/Greencard/Report/CustomerRating',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: $t('sidebar.customerReview'),
                path: '/Greencard/Report/CustomerReview',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: $t('sidebar.inspectionReport'),
                path: '/Greencard/Report/InspectionReport',
              }"
            ></sidebar-item>
          </sidebar-item>
          <sidebar-item
            :link="{
              name: $t('sidebar.pickupQR'),
              path: '/Greencard/PickupQR',
            }"
          ></sidebar-item>

          <sidebar-item :link="{ name: $t('sidebar.customerManagement') }">
            <sidebar-item
              :link="{
                name: $t('sidebar.customerRegistration'),
                path: '/Greencard/CustomerRegistration',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: $t('sidebar.customerUpdate'),
                path: '/Greencard/CustomerManagement',
              }"
            ></sidebar-item>
          </sidebar-item>
        </sidebar-item>
        <sidebar-item
          v-if="sso.incident"
          :link="{
            name: $t('sidebar.incidentReport'),
            img: require('../../assets/img/Incident.png'),
          }"
        >
          <sidebar-item
            :link="{
              name: $t('sidebar.incidentOverview'),
              path: '/IncidentReport/IncidentOverview',
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('sidebar.newJKKP'),
              path: '/IncidentReport/NewJKKP',
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('sidebar.updateJKKP'),
              path: '/IncidentReport/UpdateJKKP',
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('sidebar.newInvestigation'),
              path: '/IncidentReport/NewInvestigation',
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('sidebar.updateInvestigation'),
              path: '/IncidentReport/UpdateInvestigation',
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('sidebar.generateReport'),
              path: '/IncidentReport/GenerateReport',
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('sidebar.followUp'),
              path: '/IncidentReport/FollowUp',
            }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item
          v-if="sso.cems"
          :link="{
            name: $t('sidebar.CEMS'),
            img: require('../../assets/img/CEMS icon.png'),
          }"
        >
          <sidebar-item
            :link="{
              name: $t('sidebar.CEMOverview'),
              path: '/CEMS/Overview',
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('sidebar.CEMAnalytic'),
              path: '/CEMS/Analytic',
            }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item
          v-if="sso.cmms"
          :link="{
            name: $t('sidebar.CMMS'),
            img: require('../../assets/img/ticket.png'),
          }"
        >
          <sidebar-item
            :link="{
              name: $t('sidebar.CMMSOverview'),
              path: '/CMMS/Overview',
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('sidebar.CMMSAnalytic'),
              path: '/CMMS/Analytic',
            }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item
          v-if="sso.scada"
          :link="{
            name: $t('sidebar.Scada'),
            img: require('../../assets/img/SCADA.png'),
          }"
        >
          <sidebar-item
            :link="{
              name: $t('sidebar.ScadaOverview'),
              path: '/Scada/Overview',
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('sidebar.ScadaAnalytic'),
              path: '/Scada/Analytic',
            }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item
          v-if="sso.weigbrige"
          :link="{
            name: $t('sidebar.Weighbridge'),
            img: require('../../assets/img/Weightbridge.png'),
          }"
        >
          <sidebar-item
            :link="{
              name: $t('sidebar.WeighbridgeOverview'),
              path: '/Weighbridge/Overview',
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('sidebar.WeighbridgeAnalytic'),
              path: '/Weighbridge/Analytic',
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('sidebar.WeighbridgeManagement'),
              path: '/Weighbridge/Management',
            }"
          ></sidebar-item>

          <sidebar-item
            :link="{
              name: $t('Weekly Report'),
            }"
          >
            <sidebar-item
              :link="{
                name: $t('Domestic Waste'),
                path: '/Weighbridge/Report/Weekly/DomesticWaste',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: $t('Bulky Waste'),
                path: '/Weighbridge/Report/Weekly/BulkyWaste',
              }"
            ></sidebar-item>
          </sidebar-item>
          <sidebar-item
            :link="{
              name: $t('Monthly Report'),
            }"
          >
            <sidebar-item
              :link="{
                name: $t('Domestic Waste'),
                path: '/Weighbridge/Report/Monthly/DomesticWaste',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: $t('Bulky Waste'),
                path: '/Weighbridge/Report/Monthly/BulkyWaste',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: $t('Total Tonnage '),
                path: '/Weighbridge/Report/Monthly/TotalTonnageReport',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: $t('SAS'),
                path: '/Weighbridge/Report/Monthly/SASReport',
              }"
            ></sidebar-item>
          </sidebar-item>
        </sidebar-item>
        <sidebar-item
          v-if="isAdmin"
          :link="{
            name: $t('sidebar.userManagement'),
            img: require('../../assets/img/User Management.png'),
            path: '/UserManagement',
          }"
        ></sidebar-item>
      </template>
    </side-bar>
    <!--Share plugin (for demo purposes). You can remove it if don't plan on using it-->
    <!-- <sidebar-share :background-color.sync="sidebarBackground"> </sidebar-share> -->
    <div class="main-panel" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>
      <router-view name="header"></router-view>

      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import SidebarShare from "./SidebarSharePlugin";
function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import SidebarFixedToggleButton from "./SidebarFixedToggleButton.vue";
import { SlideYDownTransition, ZoomCenterTransition } from "vue2-transitions";

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    SidebarFixedToggleButton,
    DashboardContent,
    SlideYDownTransition,
    ZoomCenterTransition,
    SidebarShare,
  },
  data() {
    return {
      sidebarBackground: "vue", //vue|blue|orange|green|red|primary
      sso: {
        fleet: false,
        greenCard: false,
        incident: false,
        attendance: {
          all: false,
          overview: false,
          anal: false,
          overallreport: false,
          sumreport: false,
          mobilereport: false,
          empmanage: false,
          shiftcode: false,
          scheduleedit: false,
        },
        asset: false,
        cems: false,
        cmms: false,
        scada: false,
        weigbrige: false,
      },
      isAdmin: false,
      isSupervisor: false,
    };
  },
  methods: {
    getToken() {
      let jwtToken = JSON.parse(
        atob(sessionStorage.getItem("token").split(".")[1])
      );

      console.log(jwtToken);
      let flag = 0;
      if (jwtToken.roles == "ALLACCESS") {
        this.sso.asset = false;
        this.sso.attendance = false;
        this.sso.incident = false;
        this.sso.fleet = false;
        this.sso.greenCard = false;
      } else {
        for (let i = 0; i < jwtToken.namespace.length; i++) {
          if (jwtToken.namespace[i] == "GREENCARD") {
            this.sso.greenCard = true;
          }
          if (jwtToken.namespace[i] == "FLEET") {
            this.sso.fleet = true;
          }
          if (jwtToken.namespace[i] == "INCIDENT") {
            this.sso.incident = true;
          }
          if (
            jwtToken.namespace[i] == "ATTENDANCE" &&
            jwtToken.roles !== "SUPERVISOR"
          ) {
            this.sso.attendance.all = true;
          }
          if (jwtToken.namespace[i] == "ASSET") {
            this.sso.asset = true;
          }

          if (jwtToken.namespace[i] == "CEMS") {
            this.sso.cems = true;
          }

          if (jwtToken.namespace[i] == "CMMS") {
            this.sso.cmms = true;
          }

          if (
            jwtToken.roles == "SUPERVISOR" &&
            jwtToken.namespace[i] == "ATTENDANCE"
          ) {
            this.sso.attendance.scheduleedit = true;
          }
        }
      }
      console.log(jwtToken.roles);
      if (jwtToken.roles == "ADMIN" || jwtToken.roles == "ALLACCESS") {
        this.isAdmin = true;
      }

      if (
        jwtToken.employeeid == "1108" ||
        jwtToken.employeeid == "1996" ||
        jwtToken.employeeid == "6217" || 
        jwtToken.employeeid == "2000" || 
        jwtToken.employeeid == "10134"
      ) {
        this.sso.scada = true;
        this.sso.weigbrige = true;
      }
      console.log(jwtToken);

      if (flag == 1) {
        this.isSupervisor = true;
        this.isAdmin = false;
        this.sso.attendance = false;
        this.sso.greenCard = false;
        this.sso.fleet = false;
        this.sso.incident = false;
        this.sso.asset = false;
      }
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar("sidebar");
        initScrollbar("main-panel");
        initScrollbar("sidebar-wrapper");

        docClasses.add("perfect-scrollbar-on");
      } else {
        docClasses.add("perfect-scrollbar-off");
      }
    },
  },
  mounted() {
    this.getToken();
    this.initScrollbar();
  },
};
</script>
<style lang="scss">
.test {
  // background: src('@/assets/img/People.png');
  background-image: require("../../assets/img/People.png");
}
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
